import { Component, input } from '@angular/core';
import { CommonButtonRowWidget } from '../buttons/common-button-row.widget';
import { NgbAccordionModule } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'common-collapsible-card',
	imports: [CommonButtonRowWidget, NgbAccordionModule],
	templateUrl: './common-collapsible-card.widget.html',
	styles: [`
		.common-collapse-btn-header:hover{
			transform: none;
		}
	`]
})

export class CommonCollapsibleCardWidget {

	public readonly header = input.required<string>();
	public readonly buttonText = input<string>('');

}